export type UserId = 'kay' | 'lia';

export type FileKind = 'image' | 'video' | 'audio' | 'document' | 'archive' | 'text' | 'other';

export interface SessionState {
  authenticated: boolean;
  configured: boolean;
  users: UserId[];
  user?: UserId;
  expiresAt?: number;
  issuedAt?: number;
}

export interface LoginResponse {
  ok: true;
  user: UserId;
  expiresAt: number;
}

export interface UploadResult {
  ok: true;
  key: string;
  filename: string;
  prefix: string;
  user: UserId;
  size: number;
  contentType: string;
  kind: FileKind;
  url: string;
}

export interface ListedObject {
  key: string;
  filename: string;
  folder: string;
  size: number;
  uploaded: string;
  contentType: string;
  etag: string;
  kind: FileKind;
  url: string;
}

export interface ListResponse {
  ok: true;
  user: UserId;
  prefix: string;
  kind: string | null;
  objects: ListedObject[];
  folders: string[];
  total: number;
  updatedAt: string;
}

export interface ApiError {
  error: string;
}

export const USER_LABELS: Record<UserId, string> = {
  kay: 'Kay',
  lia: 'Lia',
};

export const FILE_KIND_LABELS: Record<FileKind, string> = {
  image: 'Image',
  video: 'Video',
  audio: 'Audio',
  document: 'Document',
  archive: 'Archive',
  text: 'Text',
  other: 'File',
};
